import { jwtDecode } from "jwt-decode";

// IdProduto do Agente de Contabilidade (ContabilNow).
// Mantenha em sincronia com src/features/agenteContabilidade/hooks/useAgenteContabilidadeStore.js
export const AGENTE_CONTABILIDADE_PRODUCT_ID = 9;

const getStoredToken = () =>
  localStorage.getItem("jwtToken") ||
  localStorage.getItem("authToken") ||
  sessionStorage.getItem("token");

const normalizeToken = (token) => (token?.startsWith("Bearer ") ? token.slice(7) : token);

const getSelectedCompany = () => {
  try {
    return JSON.parse(localStorage.getItem("selectedCompany") || "null");
  } catch (error) {
    return null;
  }
};

export const getAgenteContabilidadeClientContext = () => {
  const selectedCompany = getSelectedCompany();

  try {
    const token = normalizeToken(getStoredToken());
    if (token) {
      const decoded = jwtDecode(token);
      return {
        idCliente:
          decoded?.id_cliente ??
          decoded?.idCliente ??
          decoded?.idClienteAipim ??
          decoded?.cliente_id ??
          selectedCompany?.id ??
          selectedCompany?.idCliente ??
          null,
        role: decoded?.role || null,
        email: decoded?.email || decoded?.sub || "",
        nomeCliente:
          selectedCompany?.name ||
          selectedCompany?.nome ||
          selectedCompany?.nomeCliente ||
          decoded?.nomeCliente ||
          decoded?.nome_cliente ||
          "",
      };
    }
  } catch (error) {
    // fall back to selectedCompany below
  }

  return {
    idCliente:
      selectedCompany?.id ??
      selectedCompany?.idCliente ??
      selectedCompany?.id_cliente ??
      selectedCompany?.idClienteAipim ??
      null,
    role: null,
    email: "",
    nomeCliente: selectedCompany?.name || selectedCompany?.nome || selectedCompany?.nomeCliente || "",
  };
};

const getStoredContratosAtivos = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem("contratosAtivos") || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

/**
 * Acesso por PLANO/CONTRATO (mesmo padrão dos demais produtos — ex.: TaskAgent).
 * O cliente só vê/usa o Agente de Contabilidade se tiver um contrato ativo
 * para o IdProduto 9. Os contratos vêm de
 * GET /cliente/contratos-ativos (cacheados em localStorage.contratosAtivos
 * pelo hook useContratosAtivos / ProdutosContratados).
 *
 * Em DEV, basta existir o contrato (Produto 9 + Plano + Contrato ativo) para o
 * cliente — ver Backend-AgenteContabilidade-Spec.md §Acesso.
 */
export const canAccessAgenteContabilidade = () =>
  getStoredContratosAtivos().some(
    (contrato) =>
      Number(contrato?.idProduto) === AGENTE_CONTABILIDADE_PRODUCT_ID &&
      contrato?.ativo !== false
  );
